import React from "react";
import Countdown from "react-countdown"; // Assuming react-countdown is available

const CountdownRenderer = ({ paymentData, CheckStatus }) => {
  // Set the target date for the countdown (e.g., 24 hours from now)

  const renderer = ({ hours, minutes, seconds, completed }) => {
    if (completed) {
      // Render a completed state
      return (
        <span className="text-2xl font-bold text-white">
          Your payment has expired.
        </span>
      );
    } else {
      // Render a countdown
      const formatTime = (time) => String(time).padStart(2, "0");
      return (
        <div className="flex items-center justify-center space-x-4 sm:space-x-6 md:space-x-8">
          <div className="flex flex-col items-center">
            <span className="text-3xl font-semibold tracking-wide text-monochrome-400 sm:text-5xl md:text-6xl">
              {formatTime(hours)}
            </span>
            <span className=" text-xs text-monochrome-300 sm:text-base">
              Jam
            </span>
          </div>
          <span className="text-3xl font-semibold text-monochrome-400 sm:text-5xl md:text-6xl">
            :
          </span>
          <div className="flex flex-col items-center">
            <span className="text-3xl font-semibold tracking-wide text-monochrome-400 sm:text-5xl md:text-6xl">
              {formatTime(minutes)}
            </span>
            <span className=" text-xs text-monochrome-300 sm:text-base">
              Menit
            </span>
          </div>
          <span className="text-3xl font-semibold text-monochrome-400 sm:text-5xl md:text-6xl">
            :
          </span>
          <div className="flex flex-col items-center">
            <span className="text-3xl font-semibold tracking-wide text-monochrome-400 sm:text-5xl md:text-6xl">
              {formatTime(seconds)}
            </span>
            <span className=" text-xs text-monochrome-300 sm:text-base">
              Detik
            </span>
          </div>
        </div>
      );
    }
  };

  return (
    <div className="flex w-full max-w-lg flex-col items-center justify-center rounded-xl border border-monochrome-100 bg-white px-8 py-4 text-center  sm:p-12 md:p-16">
      <p className="mb-4 text-xs text-monochrome-300 sm:text-base">
        Sisa waktu pembayaran kamu!
      </p>
      <Countdown
        date={paymentData.expDate}
        renderer={renderer}
        onComplete={() =>
          // reset refund data in local storage and force user to redirect back
          CheckStatus(paymentData.id, true, true)
        }
      />
    </div>
  );
};

export default CountdownRenderer;
